module.exports = __webpack_public_path__ + "img/logo-login.c42838d3.jpeg";